import { gql, useQuery } from "@apollo/client";

export function useGetPolicyNudges(policyId: string, organisationId: string = null) {
  return useQuery(
    gql`
        query getPolicyNudges($filter: FilterFindManyCompanyPolicyNudgeInput!) {
            company_policy_nudges(filter: $filter) {
                _id
                title
                description
                status
                ai_generated
                created_by_user {
                    _id
                    name
                }
                created_at
                updated_by_user {
                    _id
                    name
                }
                updated_at
            }
        }
        `,
        {
            variables: { 
                filter: {
                    policy_id: policyId,
                    organisation_id: organisationId || undefined
                }
            },
            fetchPolicy : 'network-only'
        }
    );
}

